import Spinner from "@/Components/Spinner/Spinner";
import useLiveFilters from "@/shared/atoms/useLiveFilters";
import useLiveDayOrders from "@/shared/hooks/useLiveDayOrders";
import useLiveOrdersHook from "@/shared/hooks/useLiveOrdersHook";
import useUserSettingsQuery from "@/shared/queries/user/useUserSettingsQuery";
import {
  orderStatusses,
  orderStatussesInterface,
} from "@/shared/utils/constant";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import { DragDropContext } from "react-beautiful-dnd";
import Lane from "./Lane";

const LiveLanes = ({
  customLanes = undefined,
  data,
}: {
  customLanes?: orderStatussesInterface[];
  data: OrdersLive;
}) => {
  const [filters] = useLiveFilters();
  const dayOrders = useLiveDayOrders(data);
  const { update } = useLiveOrdersHook();
  const { data: settings } = useUserSettingsQuery();
  const onDragEnd = (result) => {
    const { source, destination, draggableId } = result;
    if (!destination) {
      return;
    }
    const { droppableId: destinationDroppableId } = destination;
    const data = dayOrders?.find(
      (order) => order.order_information.item_id == parseInt(`${draggableId}`)
    );
    if (data === undefined) {
      return;
    }
    const order = {
      orderId: draggableId,
      status: destinationDroppableId,
      branch: data.order_information.branch_id,
    };
    return update.mutate(order);
  };

  return (
    <div data-tour="live-orders.lanes" className="flex flex-wrap">
      <DragDropContext onDragEnd={onDragEnd}>
        {!dayOrders ? (
          <div className="mt-60 flex justify-center">
            <Spinner size="0.8rem" />
          </div>
        ) : customLanes ? (
          customLanes.map((s, i, list) => (
            <Lane s={s} dayOrders={dayOrders} i={i} list={list} key={s.id} />
          ))
        ) : (
          orderStatusses
            .filter((status) =>
              settings.show_only_new_orders ? status.label === "Nieuw" : true
            )
            .filter((status) => !filters.includes(status.value[0]))
            .map((s, i, list) => (
              <Lane s={s} dayOrders={dayOrders} i={i} list={list} key={s.id} />
            ))
        )}
      </DragDropContext>
    </div>
  );
};

export default LiveLanes;
